import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export const removeNote = async (note: Note): Promise<void> => {
  await supabase
    .from<Note>('notes')
    .update({ ...note, deleted: true })
    .eq('id', note.id);
};
